// extracted by mini-css-extract-plugin
export default {"container":"CustomCheckbox_container__LsyQY","checkmark":"CustomCheckbox_checkmark__HAuKA"};